import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { IdGeneratorPipe } from '../../pipes/id-generator.pipe';

@Component({
    selector: 'lib-counter-badge',
    templateUrl: './counter-badge.component.html',
    styleUrls: ['./counter-badge.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [IdGeneratorPipe]
})
export class CounterBadgeComponent {
    readonly label = input('');
    readonly count = input(0);
    readonly counterBadgeId = input<string>();
}
